import { Entity } from "../base/entity";

export class DocumentAddress extends Entity {
  public static readonly TABLENAME = "document_address";

  public static readonly DOCUMENT_ID = "document_id";
  public static readonly OBJECT_CODE = "object_code";
  public static readonly CITY = "city";
  public static readonly HOUSE_NUM = "houseNum";
  public static readonly STREET = "street";
  public static readonly POSTAL_CODE = "postal_code";
  public static readonly COUNTRY_CODE = "country_code";
  public static readonly NAPOMENA = "napomena";

  id: string;
  documentId: string;
  objectCode: string;
  city: string;
  houseNum: string;
  street: string;
  postalCode: string;
  countryCode: string;
  napomena: string;
  cityName: string;
}
